import { NgModule } from '@angular/core';

import { VerifyPincodeModule } from '@ap/tokens-browser';

import { VerifyPincodeWrapperComponent } from './verify-pincode.wrapper.component';

/**
 * @name VerifyPincodeWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [VerifyPincodeWrapperComponent],
    imports: [VerifyPincodeModule],
    exports: [VerifyPincodeWrapperComponent]
})
export class VerifyPincodeWrapperModule {}
